// src/redux/Kyc/kycSlice.js
import { createSlice } from "@reduxjs/toolkit";

const kycSlice = createSlice({
  name: "kyc",
  initialState: {
    loading: false,
    data: [],
    error: null,
    historyData: [],
    historyLoading: false,
  },
  reducers: {
    getKycListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getKycListSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || [];
      state.total = action.payload.total || 0;
      state.page = action.payload.page || 1;
      state.limit = action.payload.limit || 10;
    },
    getKycListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // KYC HISTORY
    getKycHistoryRequest: (state, action) => {
      state.historyLoading = true;
    },
    getKycHistorySuccess: (state, action) => {
      state.historyLoading = false;
      state.historyData = action.payload;
    },
    getKycHistoryFailure: (state) => {
      state.historyLoading = false;
    },
    approveRejectDocRequest: (state) => {
      state.loading = true;
    },
    approveRejectDocSuccess: (state) => {
      state.loading = false;
    },
    approveRejectDocFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Add in reducers
    revokeKycStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    revokeKycStatusSuccess: (state) => {
      state.loading = false;
    },
    revokeKycStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getKycListRequest,
  getKycListSuccess,
  getKycListFailure,
  getKycHistoryRequest,
  getKycHistorySuccess,
  getKycHistoryFailure,
  approveRejectDocRequest,
  approveRejectDocSuccess,
  approveRejectDocFailure,
  revokeKycStatusRequest,
  revokeKycStatusSuccess,
  revokeKycStatusFailure,
} = kycSlice.actions;

export default kycSlice.reducer;
